import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectIsTouchDevice = createSelector(
  (state: RootState) => state.layout.isTouchDevice,
  (isTouchDevice: boolean) => isTouchDevice
)

export default selectIsTouchDevice
